import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from '@ipc/ipc-components';
import { setTableActiveFilter, tableLoadData } from '../../../../common/list-table/actions/ListTableActions';
import {
  postCopyHandlerRequestActionCreator,
  putEditHandlersRequestActionCreator,
  clearPreservedMrdSelection,
  postAssociateHandlerRequestActionCreator,
} from '../redux/actions/HandlersActions';
import {
  getIsHandlersLoading,
  getHandlersData,
  getIsMrdDeviceListByCountryLoading,
  getMrdDeviceListByCountryData,
  getMrdDeviceListByCountryColumns,
  getLastRequestStatus,
  getSelectedMrd,
} from '../redux/selectors/HandlersSelectors';
import handlerColumn from './HandlersColumns';
import ListTable from '../../../../common/list-table/components/ListTable';
import TableDefinitions from '../../../../common/TableDefinitions';
import { HandlerStyles } from '../component/Handlers.styles';
import { getUserRole } from '../../../../common/user/redux/selectors/UserSelectors';
import HandlerCopyDialog from '../copy-handlers/component/HandlerCopyDialog';
import HandlersEditDialog from '../edit-handlers/component/HandlersEditDialog';
import HandlerAssociateDialog from '../associate-handlers/containers/HandlerAssociateDialog';

function HandlersContainer(props) {
  const {
    mrdDeviceListByCountryData,
    handlerData,
    isMrdDeviceListByCountryLoading,
    isHandlerLoading,
    mrdDeviceListByCountryColumns,
    tableLoad,
    userRole,
    copyHandlerRequest,
    editHandlerRequest,
    lastRequestStatus,
    selectedMrd,
    clearMrdRedux,
    associateHandler,
    setTableFilter,
  } = props;
  const firstItemOftheMrdList = mrdDeviceListByCountryData[0];
  const [selectedMrdDevice, updateSelectedMrdDevice] = useState('');
  const [selectedMrdDeviceNameAndId, updateSelectedMrdDeviceNameAndId] = useState();
  const [showInactive, setShowInactive] = useState(false);
  const [showAddDialog, setShowAddDialog] = useState(false);
  const [showCopyHandlerDialog, updateCopyHandlerDialog] = useState(false);
  const [showEditHandlerDialog, updateEditHandlerDialog] = useState(false);
  const [handlerToEdit, setHandlerToEdit] = useState(null);
  const showInactiveFilter = ['IPC_ADMIN', 'IPC_VIEWER', 'OPER_ADMIN', 'OPER_VIEWER'].includes(userRole);
  const showCopyHandler = ['IPC_ADMIN', 'OPER_ADMIN'].includes(userRole);
  const showAddHandler = ['IPC_ADMIN', 'OPER_ADMIN'].includes(userRole);

  useEffect(() => {
    tableLoad(TableDefinitions.MRD_DEVICE_LIST_BY_COUNTRY.id);
  }, []);

  useEffect(() => {
    if (lastRequestStatus) {
      updateCopyHandlerDialog(false);
      updateEditHandlerDialog(false);
      setShowAddDialog(false);
    }
    if (lastRequestStatus !== null && selectedMrd) {
      updateSelectedMrdDevice(selectedMrdDevice);
    }
  }, [lastRequestStatus]);

  useEffect(() => {
    if (mrdDeviceListByCountryData.length > 0 && selectedMrdDevice === '') {
      updateSelectedMrdDevice(selectedMrd || mrdDeviceListByCountryData[0].mrdName);
    } else if (selectedMrdDevice !== '') {
      tableLoad(TableDefinitions.HANDLERS_BY_MRD_DEVICE.id, { mrdName: selectedMrdDevice, active: !showInactive });
    }
  }, [mrdDeviceListByCountryData, selectedMrdDevice, showInactive]);

  useEffect(() => {
    if (selectedMrd && selectedMrd === selectedMrdDevice) {
      clearMrdRedux();
    }
  }, [selectedMrdDevice]);

  const getOnClickOfMrdDeviceTable = (state, rowInfo) => {
    if (rowInfo) {
      return {
        style: {
          background: rowInfo.original.mrdName === selectedMrdDevice ? '#dbffdb' : null,
        },
        onClick: () => {
          clearMrdRedux();
          updateSelectedMrdDevice(rowInfo.original.mrdName);
          updateSelectedMrdDeviceNameAndId(rowInfo.original);
        },
      };
    }
    return {};
  };

  const copyHandlerConfirm = (sourceMrdName) => {
    const requestData = {
      sourceMrdName,
      targetMrdName: selectedMrdDevice,
    };
    copyHandlerRequest(requestData);
  };

  const handleEditClick = (row) => {
    setHandlerToEdit(row);
    updateEditHandlerDialog(true);
  };
  const handleEditCancel = () => {
    setHandlerToEdit(null);
    updateEditHandlerDialog(false);
  };
  const editHandlerConfirm = (requestData) => {
    const data = {
      ...requestData,
      mrdName: selectedMrdDevice,
      handlerId: handlerToEdit.handlerId,
    };
    editHandlerRequest(data);
  };

  const associateHandlerSave = (requestData) => {
    associateHandler(selectedMrdDevice, requestData);
  };

  const hideAddDialog = () => {
    setShowAddDialog(false);
  };

  return (
    <HandlerStyles>
      <div className="handler-container">
        <div className="handler-table-container">
          <div className="left-table">
            <ListTable
              listId={TableDefinitions.MRD_DEVICE_LIST_BY_COUNTRY.id}
              columns={mrdDeviceListByCountryColumns}
              loading={isMrdDeviceListByCountryLoading}
              data={mrdDeviceListByCountryData}
              getTrProps={getOnClickOfMrdDeviceTable}
            />
          </div>
          {mrdDeviceListByCountryData.length > 0 && (
            <div className="right-table">
              <div className="handler-button-container">
                {showInactiveFilter && (
                  <Button
                    onClick={() => {
                      setTableFilter(TableDefinitions.HANDLERS_BY_MRD_DEVICE.id, []);
                      setShowInactive(!showInactive);
                    }}
                    className={`primary-button-${isHandlerLoading} handler-button`}
                    disabled={isHandlerLoading}
                  >
                    {`Show ${showInactive ? 'active' : 'inactive'}`}
                  </Button>
                )}
                {showAddHandler && (
                  <Button
                    onClick={() => { setShowAddDialog(true); }}
                    className={`primary-button-${isHandlerLoading} handler-button`}
                    disabled={isHandlerLoading}
                  >
                    Add
                  </Button>
                )}
                {showCopyHandler && (
                  <Button
                    onClick={() => { updateCopyHandlerDialog(true); }}
                    className={`primary-button-${!mrdDeviceListByCountryData.map((item) => item.mrdName).includes(selectedMrdDevice)} handler-button`}
                    disabled={!mrdDeviceListByCountryData.map((item) => item.mrdName).includes(selectedMrdDevice)}
                  >
                    Copy settings from other MRD
                  </Button>
                )}
              </div>
              <ListTable
                listId={TableDefinitions.HANDLERS_BY_MRD_DEVICE.id}
                columns={handlerColumn(handlerData, handleEditClick, userRole)}
                loading={isHandlerLoading}
                data={handlerData}
              />
              <HandlerCopyDialog
                isOpen={showCopyHandlerDialog}
                targetMrdName={selectedMrdDevice}
                handleConfirm={copyHandlerConfirm}
                handleCancel={() => { updateCopyHandlerDialog(false); }}
              />
              <HandlersEditDialog
                isOpen={showEditHandlerDialog}
                selectedHandler={handlerToEdit}
                handleCancel={handleEditCancel}
                handleSubmit={editHandlerConfirm}
              />
              {showAddDialog && (
                <HandlerAssociateDialog
                  openDialog={showAddDialog}
                  closeDialog={hideAddDialog}
                  selectedMrdDevice={selectedMrdDeviceNameAndId || firstItemOftheMrdList}
                  activeHandler={showInactive}
                  currentMapping={handlerData}
                  associateHandler={associateHandlerSave}
                />
              )}
            </div>

          )}
        </div>
      </div>
    </HandlerStyles>
  );
}

function mapStateToProps(state) {
  return {
    isMrdDeviceListByCountryLoading: getIsMrdDeviceListByCountryLoading(state),
    mrdDeviceListByCountryData: getMrdDeviceListByCountryData(state),
    mrdDeviceListByCountryColumns: getMrdDeviceListByCountryColumns(state),
    isHandlerLoading: getIsHandlersLoading(state),
    handlerData: getHandlersData(state),
    userRole: getUserRole(state),
    lastRequestStatus: getLastRequestStatus(state),
    selectedMrd: getSelectedMrd(state),
  };
}
const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoad: tableLoadData,
  copyHandlerRequest: postCopyHandlerRequestActionCreator,
  editHandlerRequest: putEditHandlersRequestActionCreator,
  associateHandler: postAssociateHandlerRequestActionCreator,
  clearMrdRedux: clearPreservedMrdSelection,
  setTableFilter: setTableActiveFilter,
}, dispatch);

HandlersContainer.propTypes = {
  mrdDeviceListByCountryData: PropTypes.arrayOf(PropTypes.object),
  handlerData: PropTypes.arrayOf(PropTypes.object),
  isMrdDeviceListByCountryLoading: PropTypes.bool,
  isHandlerLoading: PropTypes.bool,
  mrdDeviceListByCountryColumns: PropTypes.arrayOf(PropTypes.object),
  tableLoad: PropTypes.func,
  userRole: PropTypes.string,
  copyHandlerRequest: PropTypes.func,
  editHandlerRequest: PropTypes.func,
  lastRequestStatus: PropTypes.bool,
  selectedMrd: PropTypes.string,
  clearMrdRedux: PropTypes.func,
  associateHandler: PropTypes.func,
  setTableFilter: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(HandlersContainer);
